var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"mb-base",attrs:{"title":"Renters per Property"}},[_c('div',{staticClass:"mt-5"},[_c('e-charts',{ref:"pie",attrs:{"autoresize":"","options":_vm.pie,"auto-resize":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }